import type { CSSProperties } from 'react';

/**
 * Hands the operator's slot-lane pack size (`slotPackScale`) to the lane's
 * tiles and the glow plate, which multiply their widths by
 * `--reveal-pack-scale`. Unset, they read 1, so a stage without it keeps the
 * template's own size.
 */
export function slotPackScaleStyle(scale: number): CSSProperties {
  // A custom property is not a CSSProperties key; the value is a bare number
  return { '--reveal-pack-scale': scale } as CSSProperties;
}
